import React from 'react';
import { useConfirmation } from 'src/base/ConfirmationDialog/ConfirmationService';
import { DataGrid, Grid, IconButton, IGridColDef } from 'src/components';
import { translate } from 'src/i18n/tHelper';
import VwHbsRaportippersonelDTO from 'src/models/Raporlama/VwHbsRaportippersonelDTO';
import api from 'src/services/core/api';
import {
    useRaporTipPersonelListeQuery,
    useRaporTipPersonelSilMutation
} from 'src/services/RadyolojiModul/RadyolojiApi';
import { useAppDispatch, useAppSelector } from 'src/store';
import RaporPersonelSlice from 'src/store/Slices/Raporlama/RaporPersonelSlice';
import notify from 'src/utils/SnackbarUtils';

const translatePath = "pages|raporlama";
const RaporTipPersonelListesi = () => {
    const state1 = useAppSelector(s => s.raporlamaTanim);
    const dispatch = useAppDispatch();
    const personelIds = useAppSelector(s => s.raporPersonel.personelIds);

    const { data, isLoading, refetch } = useRaporTipPersonelListeQuery(
        { raporTipTanimId: state1.activeRow.id, turu: 1 },
        { skip: !state1.activeRow?.id }
    );
    const confirm = useConfirmation();
    const [raporTipPersonelSil] = useRaporTipPersonelSilMutation();

    const handleDelete = (row: VwHbsRaportippersonelDTO) => {
        confirm({
            description: translate(translatePath, "Personel rapordan silinecektir. Emin misiniz?"),
            catchOnCancel: true,
            title: '',
            variant: 'danger'
        }).then(() => {
            raporTipPersonelSil({ id: row.id })
                .unwrap()
                .then(() => {
                    notify.success(translate(translatePath, "Silme başarılı"));
                    dispatch(RaporPersonelSlice.actions.setPersonelIds(
                        personelIds.filter(id => id !== row.personelId)))
                    refetch();
                    dispatch(api.util.invalidateTags(["RaporPersonel"]));
                })
                .catch((error: any) => {
                    notify.error(error?.data?.message || "Silme sırasında hata oluştu.");
                });
        });
    };

    const columns: IGridColDef<VwHbsRaportippersonelDTO>[] = [
        {
            field: "adi",
            headerName: translate(translatePath, "Adı"),
            minWidth: 350
        },
        {
            field: "soyadi",
            headerName: translate(translatePath, "Soyadı"),
            width: 350
        },
        {
            disableColumnMenu: true,
            field: 'action',
            headerName: "Sil",
            sortable: false,
            filterable: false,
            resizable: false,
            width: 40,
            renderCell: (params) => (
                <IconButton
                    customType="delete"
                    onClick={() => {
                        handleDelete(params.row);
                    }}
                />
            )
        }
    ];

    return (
        <Grid container sx={{ mt: 2 }}>
            <Grid item xs={12}>
                <DataGrid
                    rows={data || []}
                    loading={isLoading}
                    getRowId={(row) => row.id}
                    columns={columns}
                    pinnedColumns={{ right: ['action'] }}
                    rowCount={data?.length || 0}
                    autoHeight
                />
            </Grid>
        </Grid>
    );
};

export default RaporTipPersonelListesi;
